<div class="header-button">
  @if (showToggleMenu) {
    <button (click)="toggleMenu()" aria-label="Abrir menú">
      <i class="ti ti-menu-2"></i>
    </button>
  }
</div>
